import { useAuth0 } from '@auth0/auth0-react';
import { ToolOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styles from './DownloadSdkSection.module.less';
import loginConfig from '../../../auth/loginConfig';

export default function DownloadSdkSection() {
	const { loginWithRedirect } = useAuth0();
	const { t } = useTranslation();
	return (
		<>
			<div className={styles.DownloadSdkSectionBackground}>
				<div className={styles.DownloadSdkSectionContainer}>
					<ToolOutlined className={styles.DownloadSdkSectionIcon} />
					<div className={styles.DownloadSdkSectionText}>
						Download our free Omni One SDK available for Unity and Unreal
					</div>
					<div
						onClick={() =>
							loginWithRedirect({
								...loginConfig,
								redirectUri: `${window.location.origin}/downloads`,
							})
						}
					>
						<div className={styles.DownloadSdkSectionButton}>Download SDK</div>
					</div>
				</div>
			</div>
		</>
	);
}
